/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum AdEvent {
  ADVERT_REQUEST_START = 'adrequeststart',
  ADVERT_REQUEST_END = 'adrequestend',
  ADVERT_BREAK_START = 'adbreakstart',
  ADVERT_BREAK_END = 'adbreakend',
  ADVERT_LOADED = 'adloaded',
  ADVERT_START = 'adstart',
  ADVERT_END = 'adend',
  ADVERT_VERIFICATION_START = 'adverificationstart',
  ADVERT_VERIFICATION_END = 'adverificationend',
  ADVERT_TRACKING_EVENT = 'adverttrackingevent',
  ADVERT_SKIP = 'adskip',
  ADVERT_SKIP_AFC_POLICY = 'adskip_afc_policy',
  ADVERT_CLICK = 'adclick',
  ADVERT_PROGRESS_UPDATE = 'adprogressupdate',
  ADVERT_ERROR = 'aderror',
  ADVERT_CUEPOINTS = 'adcuepoints',
  ADVERT_CUEPOINTS_UPDATED = 'adcuepointsupdated',
  ADVERT_INCOMING = 'adincoming',
}
